import { render, staticRenderFns } from "./peringatan.vue?vue&type=template&id=37562536"
import script from "./peringatan.vue?vue&type=script&lang=js"
export * from "./peringatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports